import React, { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { OperatorContext } from "@/components/mobile/operators";
import { OperatorPicker } from "@/components/mobile/OperatorLogo";
import { OperatorConfigForm } from "@/components/mobile/OperatorConfigForm";
import { AdminSimStock } from "@/components/sim/AdminSimStock";
import { OperatorCredits } from "@/components/mobile/OperatorCredits";

export default function AdminMobileOperators() {
  const [items, setItems] = useState(null);
  const [params, setParams] = useSearchParams();
  const load = useCallback(() => { api.get("/admin/mobile-operators").then((r) => setItems(r.data.items || [])).catch(() => toast.error("Operatori non disponibili")); }, []);
  useEffect(() => { load(); }, [load]);
  if (!items) return <p className="text-sm text-muted-foreground">Caricamento…</p>;
  const op = items.find((o) => o.key === params.get("operatore")) || items[0];
  const tab = params.get("tab") === "magazzino" && op.kind === "sim" ? "magazzino" : "prezzi";
  const go = (patch) => setParams((p) => { const n = new URLSearchParams(p); Object.entries(patch).forEach(([k, v]) => n.set(k, v)); return n; });
  return (
    <div className="space-y-6" data-testid="admin-mobile-operators">
      <div>
        <p className="text-xs font-medium tracking-wider uppercase text-muted-foreground">Mobile</p>
        <h1 className="font-head text-3xl font-bold tracking-tight mt-2">Operatori mobili</h1>
        <p className="text-sm text-muted-foreground mt-1">Per ogni operatore: offerte con canone e primo mese, costo attivazione, aggio e provvigioni, prezzo SIM con scaletta e magazzino.</p>
      </div>
      <OperatorCredits items={items} />
      <OperatorPicker ops={items} value={op.key} onChange={(k) => go({ operatore: k, tab: "prezzi" })} testid="admin-op-picker" />
      {op.kind === "sim" && <Tabs value={tab} onValueChange={(v) => go({ tab: v })}>
        <TabsList data-testid="admin-op-tabs">
          <TabsTrigger value="prezzi" data-testid="admin-op-tab-prezzi">Prezzi e offerte</TabsTrigger>
          <TabsTrigger value="magazzino" data-testid="admin-op-tab-magazzino">Magazzino e ordini SIM ({op.platform_stock ?? 0})</TabsTrigger>
        </TabsList>
      </Tabs>}
      <OperatorContext.Provider value={op}>
        <div key={`${op.key}-${tab}`}>{tab === "magazzino" ? <AdminSimStock /> : <OperatorConfigForm op={op} onSaved={load} />}</div>
      </OperatorContext.Provider>
    </div>
  );
}
